import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'
import { organisationsQueryOptions } from '@/api/resources/organisations'
import { LoadingSpinner } from '@/components/feedback/loading-spinner'
import { PageHeader } from '@/components/layout/page-header'
import { UserOrganisationCard } from '@/components/users/user-organisation-card'

export const Route = createFileRoute('/_app/users/')({
  head: () => ({ meta: [{ title: 'Users - MyJunea' }] }),
  component: UsersIndexPage,
})

function UsersIndexPage(): React.ReactElement {
  const { data: organisations, isLoading } = useQuery(organisationsQueryOptions())

  return (
    <div className="space-y-6">
      <PageHeader
        title="Users"
        description="Manage system managers and operators for your organisations."
      />

      {isLoading && <LoadingSpinner />}

      {!isLoading && (organisations === undefined || organisations.length === 0) && (
        <p className="text-muted-foreground py-10 text-center">No organisations found.</p>
      )}

      {organisations !== undefined && organisations.length > 0 && (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          {organisations.map((organisation) => (
            <Link
              key={organisation.id}
              to="/users/$organisationId"
              params={{ organisationId: String(organisation.id) }}
              className="focus-visible:ring-ring min-w-0 rounded-xl transition-transform hover:scale-[1.02] focus-visible:ring-2 focus-visible:outline-none"
            >
              <UserOrganisationCard
                name={organisation.name}
                systemManagersCount={organisation.system_managers_count}
                operatorsCount={organisation.operators_count}
                className="h-full"
              />
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}
